import { downloadDocument } from 'API/order/documents/downloadDocument';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { initAdminDocumentHistory } from 'store/order/documents/adminDocuments/dispatch';
import { useAppDispatch } from 'store/store';
import { RootStore } from 'store/types';
import { BodyText } from 'ui-toolkit';

export interface IDocumentDownloadContainerProps {}

export const DocumentDownloadContainer: React.FC<IDocumentDownloadContainerProps> = () => {
  const { documentId } = useParams<{ orderId: string; documentId: string }>();
  const { documentHistory } = useSelector((state: RootStore) => state.order.documents.adminDocuments);

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(initAdminDocumentHistory(documentId));
  }, [documentId, dispatch]);
  useEffect(() => {
    if (documentHistory && documentHistory[documentId] && documentHistory[documentId][0]) {
      const document = documentHistory[documentId][0];
      downloadDocument(document.id, document.versionId, document.fileName);
    }
  }, [documentHistory, documentId]);
  return <BodyText>Downloading, once done this tab can be closed</BodyText>;
};
